document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.quick-add__button .add-to-cart-text__content').forEach(function (el) {
    el.textContent = 'In den Warenkorb';
  });
});

// Fix: Apple Pay/Google Pay ignorieren die CSS-Variable fuer die Button-Hoehe teilweise,
// wenn sie nur per Stylesheet gesetzt wird. Inline per JS gesetzt hat hoechste Prioritaet
// und wird zuverlaessiger von allen drei Wallet-Buttons uebernommen.
function applyAcceleratedCheckoutSize() {
  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var size = isMobile ? '36px' : '';
  document.querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart').forEach(function (el) {
    if (size) {
      el.style.setProperty('--shopify-accelerated-checkout-button-block-size', size);
      el.style.setProperty('--shopify-accelerated-checkout-button-inline-size', '22%');
      el.style.setProperty('--shopify-accelerated-checkout-row-gap', '4px');
    } else {
      el.style.removeProperty('--shopify-accelerated-checkout-button-block-size');
      el.style.removeProperty('--shopify-accelerated-checkout-button-inline-size');
      el.style.removeProperty('--shopify-accelerated-checkout-row-gap');
    }
  });
}

document.addEventListener('DOMContentLoaded', applyAcceleratedCheckoutSize);
document.addEventListener('cart:update', function () {
  window.setTimeout(applyAcceleratedCheckoutSize, 50);
  window.setTimeout(applyAcceleratedCheckoutSize, 400);
});
window.addEventListener('resize', applyAcceleratedCheckoutSize);

// Fix: PayPal (und andere Express-Checkout-Popups) landen hinter dem geoeffneten
// Warenkorb-Fenster (natives <dialog> liegt im Top-Layer ueber allem anderen).
// Deshalb: Warenkorb-Dialog sofort schliessen, sobald ein Express-Checkout-Button
// im Warenkorb angeklickt wird, damit das Zahlungsfenster ungehindert vorne liegt.
document.addEventListener(
  'click',
  function (event) {
    // Nur auf Mobile: Am Desktop war der Warenkorb schon vorher kein Problem fuer PayPal & co.,
    // und das sofortige Schliessen hat dort den Klick auf den Zahlungs-Button gestoert.
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var checkoutArea = event.target.closest(
      '.cart-drawer shopify-accelerated-checkout-cart, .cart-drawer .additional-checkout-buttons'
    );
    if (!checkoutArea) return;

    var dialog = document.querySelector('.cart-drawer__dialog[open]');
    if (dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
  },
  true
);
